import { SelectOption } from '@synqo/frontend-component-library';

export type CreateInvoiceTableModes = 'create' | 'latest';
export const createInvoiceTableModes: SelectOption<CreateInvoiceTableModes>[] = [
    {
        name: 'create',
        label: 'Rechnungen erzeugen',
        value: 'create',
    },
    {
        name: 'latest',
        label: 'Mein letzter Rechnungslauf',
        value: 'latest',
    },
];
